import { render } from "./EmailLogin.vue?vue&type=template&id=ef477eea"
import script from "./EmailLogin.vue?vue&type=script&lang=js"
export * from "./EmailLogin.vue?vue&type=script&lang=js"

import "./EmailLogin.vue?vue&type=style&index=0&id=ef477eea&lang=less&scope=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__